import type { TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';

export const verifyRoofYear: TaskDefinition = {
  taskName: onboardingTasks.VerifyRoofYear,
  config: {
    staffDisplayName: 'Verify Roof Year',
    reviewTeam: reviewTeams.uwOps,
    daysAllowed: 15,
    enabled: true,
    account: {
      toastMessage: 'Your proof of roof replacement has been submitted for review.',
      content: ({ affectedPolicies }) => ({
        title: 'Verify roof year',
        incompleteSubtitle:
          'Our satellite imagery data partner shows your roof is older than the year on your policy. Please provide proof of the year your roof was fully replaced to maintain your selection.',
        completedSubtitle: `You have successfully submitted proof of roof replacement for ${affectedPolicies}.`,
        actionLabel: 'Upload Proof',
        modalTitle: 'Upload your proof of roof replacement',
        contentSections: [
          {
            title: 'What counts as proof?',
            body: [
              'Paid invoice showing a full roof replacement and the year',
              'Signed contract showing work completed date',
              "For newly purchased homes only: roof replacement permits or seller's disclosures"
            ],
            isList: true
          }
        ]
      })
    }
  }
};
